import '@vkontakte/vkui/dist/components.css';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { ErrorBoundary } from './shared/ui';
import { ErrorPage } from './pages/ErrorPage';
import './fonts.css';
import { envs } from './core';

async function main() {
  const container = document.getElementById('root');
  const root = createRoot(container!);

  console.log(`Running app with build number ${envs.BUILD_NUMBER}, commitHash ${envs.BUILD_COMMIT}`);

  root.render(
    <ErrorBoundary fallback={(retry) => <ErrorPage onRetry={retry} />}>
      <App />
    </ErrorBoundary>,
  );
}

main();
